import { createDomain, sample } from 'effector'
import { AxiosErrorType, Tasks } from '~/shared/api'
import { mapMessageErrors } from '~/shared/lib/mapMessageErrors'
import { snackbarEnqueued } from '~/shared/lib/notifications'

const domain = createDomain('features.drivers.aggregators.syncBalanceModal')

export const syncBalanceFx = domain.createEffect<
  {
    aggregatorProfileId: UniqueId
    fromDate: string
    toDate: string
  },
  void,
  AxiosErrorType
>({
  handler: async ({ aggregatorProfileId, fromDate, toDate }) => {
    await Tasks.syncBalance({ aggregatorProfileId, fromDate, toDate })
  },
})

sample({
  clock: syncBalanceFx.doneData,
  fn() {
    return {
      messageI18n: 'alert.balance synced task created' as const,
      variant: 'success' as const,
    }
  },
  target: snackbarEnqueued,
})

sample({
  clock: syncBalanceFx.failData,
  fn(e) {
    return {
      message: mapMessageErrors(e),
      variant: 'error' as const,
    }
  },
  target: snackbarEnqueued,
})
